/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent, memo } from "react";

type Props = {
  className?: string;
};

const Logo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block", className)}
    fill="none"
    viewBox="0 0 120 29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.077 25.389c0 .2.1.301.2.301.101 0 .201 0 .302-.1L106.71 1.504c.603-.402 1.405-.703 2.208-.703h8.129c1.104-.1 2.008.803 2.108 1.907v15.756c0 1.907-.402 3.01-2.108 4.015l-9.935 5.92c-.1.101-.201.101-.301.101-.101 0-.201-.1-.201-.401V9.934c0-.201-.1-.301-.201-.301-.1 0-.2 0-.301.1L78.912 27.396c-.602.401-1.405.602-2.107.602H58.74c-1.104.1-2.007-.803-2.107-1.907V3.411c0-.101-.1-.302-.201-.302-.1 0-.2 0-.301.1L38.367 14.05c-.1 0-.2.2-.2.3 0 .1.1.201.2.301l12.846 12.846c.1.1.2.302.301.402 0 .2-.2.2-.401.2H39.37c-.803.1-1.506-.1-2.108-.602l-7.727-7.727c-.1-.2-.1-.2-.2-.2-.101 0-.202 0-.202.1l-13.046 7.827c-.602.402-1.405.603-2.108.603H2.138c-1.104.1-2.007-.803-2.108-1.907V10.636a3.99 3.99 0 0 1 2.108-4.014L12.073.7c0-.201.1-.201.201-.201.1 0 .2.2.2.502v20.573c0 .201.101.301.202.301.1 0 .2-.1.3-.1L46.698 1.403c.703-.401 1.405-.702 2.208-.602h18.064c1.104-.1 2.008.803 2.108 1.907v22.68Z"
      fill="#000"
    />
  </svg>
);

export const KiaLogo = memo(Logo);
